import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import UserFormModal from './UserFormModal';

const EditUserButton = ({ columnData, onUpdateUser }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const showModal = () => {
    setModalVisible(true);
  };
  const hideModal = () => {
    setModalVisible(false);
  };
  const onSubmit = async (data) => {
    const payloadObj = {
      faq_id: columnData.id,
      payload: { equip_faq: data },
    };
    await onUpdateUser(payloadObj);
    hideModal();
  };
  return (
    <>
      <UserFormModal
        data={columnData}
        onSubmit={onSubmit}
        onCancel={hideModal}
        visible={modalVisible}
        title={`Edit FAQ - ${columnData.name}`}
        submitText="Update FAQ"
      />
      <Tooltip title={`Edit FAQ - ${columnData.name}`}>
        <Button icon={<EditOutlined />} onClick={showModal} />
      </Tooltip>
    </>
  );
};
export default EditUserButton;
